// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"ColorPicker_colorPicker__f9NUw","chromePicker":"ColorPicker_chromePicker__oc5Xw","palette":"ColorPicker_palette__3o6d9"};